import React from 'react';
import useHtmlTableCellProps from './useHtmlTableCellProps';
/**
 * The renderer component for `th` tag.
 *
 * @param props - Component props.
 * @public
 */

const ThRenderer = function ThRenderer(props) {
  return /*#__PURE__*/React.createElement(props.TDefaultRenderer, useHtmlTableCellProps(props));
};

export default ThRenderer;
//# sourceMappingURL=ThRenderer.js.map